angular.module('impactx.monitordashboard').controller('BusinessOrderListCtrl', BusinessOrderListCtrl);

function BusinessOrderListCtrl() {
    this.meta = {
        rowTemplate: 'modules/monitor/templates/businessorder.row.html',
        isSelectAble: false,
        endpoint: '/business/order',
        ctrl: this,
        id: "businessorderlist",
        excelExport: true
    };
    this.getMeta = function () {
        return this.meta;
    };
}